import { BACKEND_URL } from '@/config';
import axios from 'axios';

export const axiosUser = axios.create({
  baseURL: BACKEND_URL
});

export const axiosSuperAdmin = axios.create({
  baseURL: BACKEND_URL
});
